import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useSystemConfiguration } from '@/api/system-configuration/use-system-configuration';
import LanguageSelectorDropdown from '@/theme/LanguageSelectorDropdown';

const MobileTraderHeader: React.FC = () => {
    const { user } = useAuth();
    const { data: systemConfig } = useSystemConfiguration();

    const initials =
        user?.name
            ?.split(' ')
            .slice(0, 2)
            .map(w => w[0])
            .join('')
            .toUpperCase() ?? '?';

    return (
        <header className="sticky top-0 z-40 px-4 py-3 backdrop-blur-xl border-b border-white/5 bg-background/30">
            <div className="grid grid-cols-3 items-center">
                {/* Left: avatar + greeting */}
                <div className="flex items-center gap-2">
                    <div className="w-9 h-9 rounded-full trader-glass border border-white/20 flex items-center justify-center text-xs font-bold flex-shrink-0">
                        {initials}
                    </div>
                    <div className="flex flex-col min-w-0">
                        <span className="text-muted-foreground text-[10px] font-medium leading-none mb-0.5">
                            Welcome back,
                        </span>
                        <span className="text-foreground text-sm font-semibold truncate leading-none">
                            {user?.name?.split(' ')[0] ?? ''}
                        </span>
                    </div>
                </div>

                {/* Center: brand logo */}
                <div className="flex justify-center">
                    {systemConfig?.system_logo_url || systemConfig?.logo_url ? (
                        <img
                            src={systemConfig.system_logo_url || systemConfig.logo_url}
                            alt={systemConfig.system_name || 'Logo'}
                            className="h-8 w-auto object-contain"
                        />
                    ) : (
                        <div className="w-9 h-9 rounded-full trader-fab-gradient flex items-center justify-center text-lg font-bold text-white">
                            {(systemConfig?.system_name || 'Q').charAt(0).toUpperCase()}
                        </div>
                    )}
                </div>

                {/* Right: language selector */}
                <div className="flex justify-end">
                    <LanguageSelectorDropdown compact />
                </div>
            </div>
        </header>
    );
};

export default MobileTraderHeader;
